module.exports = __webpack_public_path__ + "img/bg-3.3e7a8f43.png";